import React from 'react';
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Typography, Divider, InfoField, ChipBox } from '@occc-app/design-system';
import { EarningMechanismVarietyDiscountFragment } from '@occc/graphql';

interface IVarietyDiscountProps {
  earningMechanism: EarningMechanismVarietyDiscountFragment;
}

export const VarietyDiscount: React.FC<IVarietyDiscountProps> = ({ earningMechanism }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <>
      <Typography variant='subtitle1' component='h4' paragraph>
        Product Definition
      </Typography>
      {earningMechanism.purchases.length &&
        earningMechanism.purchases.map((item, index) => (
          <div key={index}>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <InfoField
                  disableTypography
                  label='Included Product Groups'
                  value={
                    <ChipBox items={item.eligibleProductGroups} onClick={onChipClick} mt={0} />
                  }
                />
              </Grid>
              <Grid item sm>
                <InfoField value={item?.purchaseThreshold} label='Purchase Threshold' />
              </Grid>
            </Grid>
            {earningMechanism.purchases.length - 1 !== index && (
              <Box mx={0} mt={1} mb={2}>
                <Divider sx={{ mt: 2 }} />
                <Typography variant='subtitle1' component='p'>
                  and
                </Typography>
              </Box>
            )}
          </div>
        ))}
    </>
  );
};
